import http from "./client";

interface ICheckWhatsappResponse {
  success: boolean;
  message?: string;
  errorMessage?: string;
  timeout?: number;
}

export async function check(phone: string): Promise<ICheckWhatsappResponse> {
  const response = await http.post('/api/whatsapp/send', {
    phone: phone
  });
  return response.data;
}

const whatsapp = {
  check,
}

export default whatsapp